@import "../../../global/gx-ide-common.scss";
@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/temporary-tokens-chameleon.scss";

:host {
  display: block;
}
